<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Indicadores de Diferencia de Plazos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="indicadores" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaVigenciaDesde)="data">
              {{ data.item.fechaVigenciaDesde | fecha }}
            </template>
            <template v-slot:cell(fechaVigenciaHasta)="data">
              {{ data.item.fechaVigenciaHasta | fecha }}
            </template>
            <template v-slot:cell(pjeObjetivo)="data">
              {{ data.item.pjeObjetivo | numero(2, true) }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Indicador</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'indicadores/getField',
  mutationType: 'indicadores/updateField',
});

export default {
  name: 'IndicadoresPlazoList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      fields: [
        { 
          key: 'indicadorPeriodo',
          label: 'Periodo'
        },
        { key: 'fechaVigenciaDesde' },
        { key: 'fechaVigenciaHasta' },
        {
          key: 'plazoObjetivo',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'indicadores',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('indicadores/getIndicadores', 'indicadores-plazo')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$router.push({ name: 'IndicadorPlazoAdd' });
    },
    editar (item) {
      this.$router.push({ name: 'IndicadorPlazoEdit',
                          params: { id: item.id } });
    },
    consultar (item) {
      this.$router.push({ name: 'IndicadorPlazoData', 
                          params: { id: item.id }});
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
